"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShiftAresGlobalParameters = void 0;
var vue_1 = require("vue");
exports.ShiftAresGlobalParameters = vue_1.default.component('shift-ares-global-parameters', {
    props: {
        playerinput: {
            type: Object,
        },
        onsave: {
            type: Function,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    data: function () {
        var hazardData = this.playerinput.aresData.hazardData;
        return {
            hazardData: hazardData,
            lowOceanDelta: 0,
            highOceanDelta: 0,
            temperatureDelta: 0,
            oxygenDelta: 0,
            ADJUSTMENT_RANGE: [-1, 0, 1],
        };
    },
    methods: {
        saveData: function () {
            var response = {
                lowOceanDelta: this.$data.lowOceanDelta,
                highOceanDelta: this.$data.highOceanDelta,
                temperatureDelta: this.$data.temperatureDelta,
                oxygenDelta: this.$data.oxygenDelta,
            };
            this.onsave([[
                    JSON.stringify(response),
                ]]);
        },
    },
    template: "\n<div class=\"wf-component\">\n    <div v-if=\"hazardData.erosionOceanCount.available\">\n        Reveal erosions at:&nbsp;\n        <label class=\"form-radio form-inline ares-global-parameter-label\" v-for=\"value in ADJUSTMENT_RANGE\">\n          <input type=\"radio\" :value=\"value\" name=\"lowOceanDelta\" v-model=\"lowOceanDelta\">\n          <i class=\"form-icon\" />\n          <div class=\"ares-global-parameter-option\">{{ value + hazardData.erosionOceanCount.threshold }} oceans.</div>\n        </label>\n    </div>\n\n    <div v-if=\"hazardData.removeDustStormsOceanCount.available\">\n        Remove dust storms at:&nbsp;\n        <label class=\"form-radio form-inline ares-global-parameter-label\" v-for=\"value in ADJUSTMENT_RANGE\">\n          <input type=\"radio\" :value=\"value\" name=\"highOceanDelta\" v-model=\"highOceanDelta\">\n          <i class=\"form-icon\" />\n          <div class=\"ares-global-parameter-option\">{{ value + hazardData.removeDustStormsOceanCount.threshold }} oceans</div>\n        </label>\n    </div>\n\n    <div v-if=\"hazardData.severeErosionTemperature.available\">\n        Amplify erosions at:&nbsp;\n        <label class=\"form-radio form-inline ares-global-parameter-label\" v-for=\"value in ADJUSTMENT_RANGE\">\n          <input type=\"radio\" :value=\"value\" name=\"temperatureDelta\" v-model=\"temperatureDelta\">\n          <i class=\"form-icon\" />\n          <div class=\"ares-global-parameter-option\">{{ (2 * value) + hazardData.severeErosionTemperature.threshold }} \u00B0C</div>\n        </label>\n    </div>\n\n    <div v-if=\"hazardData.severeDustStormOxygen.available\">\n        Amplify dust storms at:&nbsp;\n        <label class=\"form-radio form-inline ares-global-parameter-label\" v-for=\"value in ADJUSTMENT_RANGE\">\n          <input type=\"radio\" :value=\"value\" name=\"oxygenDelta\" v-model=\"oxygenDelta\">\n          <i class=\"form-icon\" />\n          <div class=\"ares-global-parameter-option\">{{ value + hazardData.severeDustStormOxygen.threshold }}% oxygen</div>\n        </label>\n    </div>\n\n    <div v-if=\"showsave === true\" class=\"nofloat\">\n        <button class=\"btn btn-primary btn-submit\" v-on:click=\"saveData\">{{playerinput.buttonLabel}}</button>\n    </div>\n</div>\n",
});
//# sourceMappingURL=ShiftAresGlobalParameters.js.map